// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__1ep5z","load8":"style_load8__3C67g"};